import { AppointmentModalityType, AppointmentSessionType, AppointmentStatus, HowToPayType, PaymentScheduleType } from "./enums";

export interface IAppointment {
    id: number;
    virtual_patient_id: number;
    virtual_therapist_id: number;
    clinic_id: number;
    status: AppointmentStatus;
    time_slot: Date;
    created_at: Date;
    session_type: AppointmentSessionType;
    modality_type: AppointmentModalityType;
    appointment_price: number;
    payment_schedule: PaymentScheduleType;
    how_to_pay: HowToPayType;
    is_paid: boolean;
    therapist?: { id: number, full_name: string };
}

export class AppointmentModel implements IAppointment {
    id: number;
    virtual_patient_id: number;
    virtual_therapist_id: number;
    clinic_id: number;
    status: AppointmentStatus;
    time_slot: Date;
    created_at: Date;
    session_type: AppointmentSessionType;
    modality_type: AppointmentModalityType;
    appointment_price: number;
    payment_schedule: PaymentScheduleType;
    how_to_pay: HowToPayType;
    is_paid: boolean;
    therapist?: { id: number, full_name: string };

    get isCompleted() {
        const end = new Date(this.time_slot);
        end.setHours(end.getHours() + 1);
        return this.status === AppointmentStatus.Confirmed && end < new Date();
    }

    get hasStarted() {
        return this.status === AppointmentStatus.Confirmed && new Date() >= this.time_slot;
    }

    get isInProgress() {
        return this.status === AppointmentStatus.Confirmed && this.hasStarted && !this.isCompleted;
    }

    constructor(appointment: IAppointment) {
        this.id = appointment.id;
        this.virtual_patient_id = appointment.virtual_patient_id;
        this.virtual_therapist_id = appointment.virtual_therapist_id;
        this.clinic_id = appointment.clinic_id;
        this.status = appointment.status;
        this.time_slot = appointment.time_slot;
        this.created_at = appointment.created_at;
        this.session_type = appointment.session_type;
        this.modality_type = appointment.modality_type;
        this.appointment_price = appointment.appointment_price;
        this.payment_schedule = appointment.payment_schedule;
        this.how_to_pay = appointment.how_to_pay;
        this.is_paid = appointment.is_paid;
        this.therapist = appointment.therapist;
    }
}
